import { DEFAULT_USER_IMG_URL, MAIN_WEBSITE_URL } from "../constants/Globals";
import moment from "moment";

export default async function CopyEmailEmbedForSequence({
  stepFirstDebateData,
  sequenceLength,
  paramsId,
  setAlertMessage,
}) {
  if (!stepFirstDebateData) {
    setAlertMessage("No email embed available to copy");
    return;
  }

  const poll = stepFirstDebateData?.debate || stepFirstDebateData;
  const cta = stepFirstDebateData?.callToAction || null;
  const product = stepFirstDebateData?.product || null;
  const form = stepFirstDebateData?.form || null;
  const signup = stepFirstDebateData?.signupForm || null;

  const sides = poll?.sides || [];
  const userImage =
    poll.user?.avatarObject?.thumb?.location || DEFAULT_USER_IMG_URL;
  const postedAt = moment(poll.startedAt).format("MMM DD, YYYY");

  const endedOrEnds = poll.isClosed
    ? `${poll?.isQuestion ? "Question" : "Poll"} ended`
    : `${poll?.isQuestion ? "Question" : "Poll"} ends`;

  const endedAtForMailEmbed = poll?.endedAt
    ? `${endedOrEnds} ${moment(poll.endedAt).format("MMM DD, YYYY")}`
    : "";

  let emailEmbedSides = "";

  if (sides.length) {
    for (let i = 0; i < sides.length; i++) {
      if (poll.isClosed) {
        const voteResult = !isNaN(
          ((sides[i].votes * 100) / poll.votes).toFixed(2),
        )
          ? ((sides[i].votes * 100) / poll.votes).toFixed(2) + "%"
          : "";

        emailEmbedSides += `
          <tr>
            <td colspan="2" style="padding-bottom:9px">
              <a href="${MAIN_WEBSITE_URL}/preview/${paramsId}"
                style="position:relative;display:block;padding:8px;font-size:14px;font-weight:600;color:#000;text-decoration:none;border-radius:6px;background:${sides[i].sideColor}10;border-left:5px solid ${sides[i].sideColor};">
                <span style="position:relative;z-index:1">${sides[i].text}<span style="float:right">${voteResult}</span></span>
                <span style="position:absolute;left:0;top:0;bottom:0;width:${voteResult};background:${sides[i].sideColor}26;"></span>
              </a>
            </td>
          </tr>`;
      } else {
        emailEmbedSides += `
          <tr>
            <td colspan="2" style="padding-bottom:9px">
              <a href="${MAIN_WEBSITE_URL}/preview/${paramsId}"
                style="display:block;padding:10px;font-size:14px;font-weight:600;text-align:center;color:#000;text-decoration:none;border-radius:10px;border:1px solid #60a4e9;">
                ${sides[i].text}
              </a>
            </td>
          </tr>`;
      }
    }
  }

  const stepWidth = Math.floor(100 / sequenceLength);
  let topNavSteps = `<tr><td colspan="2" style="padding:20px 20px 6px 20px"><table width="100%" cellpadding="0" cellspacing="0"><tr>`;
  for (let i = 0; i < sequenceLength; i++) {
    const isActive = i === 0;
    const paddingLeft = i === 0 ? "" : "padding-left:5px";
    const bgColor = isActive ? "rgb(79, 79, 79)" : "#e0e0e0";
    topNavSteps += `
      <td width="${stepWidth}%" style="${paddingLeft}">
        <div style="height:7px;border-radius:100px;background-color:${bgColor};"></div>
      </td>`;
  }
  topNavSteps += `</tr></table></td></tr>`;

  // Build inner content depending on part type: poll, cta, product, or form
  let innerContent = "";

  if (cta) {
    const c = cta;
    const ctaImage = c.ctaImage
      ? c.ctaImage.startsWith("http")
        ? c.ctaImage
        : `https://cdn.sided.co/${c.ctaImage}`
      : null;

    innerContent = `
      <!-- CTA CONTENT -->
      <tr>
        <td colspan="2" style="padding:10px 20px 6px 20px; background:${c.styleBackground?.color || "#ffffff"};">
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation">

           ${
              ctaImage
                ? `
            <!-- IMAGE -->
            <tr>
              <td align="center" style="padding-bottom:8px">
                <img
                  src="${ctaImage}"
                  alt=""
                  style="display:block;max-width:100%;height:auto;border:0;outline:none;text-decoration:none;"
                />
              </td>
            </tr>`
                : ""
            }
            
            <!-- TITLE -->
            <tr>
              <td style="font-size:18px;line-height:22px;font-weight:700;color:${c.styleTitle?.color};padding-bottom:20px;">
                ${c.title || ""}
              </td>
            </tr>

            <!-- DESCRIPTION -->
            <tr>
              <td style="font-size:14px;line-height:20px;color:${c.styleDescription?.color};padding-bottom:20px;">
                ${c.description || ""}
              </td>
            </tr>

            <!-- BUTTON -->
            <tr>
              <td align="center" style="padding-bottom:8px;">
                <table cellpadding="0" cellspacing="0" role="presentation" width="100%">
                  <tr>
                    <td
                      style="
                        background:${(c.styleButton && c.styleButton.color) || "#2F80ED"};
                        border-radius:6px;
                        border:1px solid;
                        text-align:center;
                      "
                    >
                      <a
                        href="${MAIN_WEBSITE_URL}/preview/${paramsId}"
                        target="_blank"
                        style="
                          display:inline-block;
                          padding:10px 16px;
                          font-size:14px;
                          font-weight:600;
                          color:${(c.styleButton && c.styleButton.textColor) || "#ffffff"};
                          text-decoration:none;
                          border-radius:6px;
                          mso-padding-alt:0;
                        "
                      >
                        ${c.buttonText || "Learn More"}
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

          </table>
        </td>
      </tr>
    `;
  } else if (product) {
    const p = product;
    const pImage = p.productImage
      ? p.productImage.startsWith("http")
        ? p.productImage
        : `https://cdn.sided.co/${p.productImage}`
      : null;

    innerContent = `
      <!-- PRODUCT CONTENT -->
      <tr>
        <td colspan="2" style="padding:20px 20px 20px 20px; background:${p.styleBackground?.color || "#ffffff"};">
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation">

            <!-- IMAGE -->
            ${
              pImage
                ? `
            <tr>
              <td align="center" style="padding-bottom:10px;">
                <img
                  src="${pImage}"
                  alt=""
                  style="display:block;max-width:100%;height:auto;border:0;outline:none;text-decoration:none;"
                />
              </td>
            </tr>`
                : ""
            }

            <!-- TITLE -->
            <tr>
              <td
                style="
                  font-size:${p.styleTitle?.fontSize || "18px"};
                  line-height:22px;
                  font-weight:700;
                  color:${p.styleTitle?.color || "#000"};
                  padding-bottom:20px;
                  word-break:break-word;
                "
              >
                ${p.title || ""}
              </td>
            </tr>

            <!-- DESCRIPTION -->
            <tr>
              <td
                style="
                  font-size:${p.styleDescription?.fontSize || "14px"};
                  line-height:20px;
                  color:${p.styleDescription?.color || "#4a4a4a"};
                  padding-bottom:20px;
                  word-break:break-word;
                "
              >
                ${p.description || ""}
              </td>
            </tr>

            <!-- PRICE -->
            <tr>
              <td
                style="
                  font-size:${p.stylePrice?.fontSize || "14px"};
                  font-weight:700;
                  color:${p.stylePrice?.color || "#000"};
                  padding-bottom:20px;
                "
              >
                $ ${p.price || ""}
              </td>
            </tr>

            <!-- BUTTON -->
            <tr>
              <td align="center">
                <table cellpadding="0" cellspacing="0" role="presentation" width="100%">
                  <tr>
                    <td
                      style="
                        background:${p.styleButton?.color || "#2F80ED"};
                        border-radius:6px;
                        text-align:center;
                      "
                    >
                      <a
                        href="${MAIN_WEBSITE_URL}/preview/${paramsId}"
                        target="_blank"
                        style="
                          display:inline-block;
                          padding:10px 16px;
                          font-size:${p.styleButton?.fontSize || "14px"};
                          font-weight:600;
                          color:${p.styleButton?.textColor || "#ffffff"};
                          text-decoration:none;
                          border-radius:6px;
                          mso-padding-alt:0;
                        "
                      >
                        ${p.buttonText || "Buy"}
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

          </table>
        </td>
      </tr>
    `;
  } else if (form) {
    const f = form;
    const formImage = f.image ? `https://cdn.sided.co/${f.image}` : null;

    innerContent = `
      <!-- FORM CONTENT -->
      <tr>
        <td colspan="2" style="padding:10px 20px 6px 20px;">
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation">

            <!-- TITLE -->
            <tr>
              <td
                style="
                  font-size:18px;
                  line-height:22px;
                  font-weight:700;
                  color:#000;
                  padding-bottom:4px;
                  word-break:break-word;
                "
              >
                ${f.title || ""}
              </td>
            </tr>

            <!-- DESCRIPTION -->
            <tr>
              <td
                style="
                  font-size:14px;
                  line-height:20px;
                  color:#4a4a4a;
                  padding-bottom:10px;
                  word-break:break-word;
                "
              >
                ${f.description || ""}
              </td>
            </tr>

            ${
              formImage
                ? `
            <!-- IMAGE -->
            <tr>
              <td style="padding-bottom:10px;">
                <img
                  src="${formImage}"
                  alt="Form"
                  style="
                    display:block;
                    width:100%;
                    max-width:100%;
                    height:auto;
                    border:0;
                    outline:none;
                    text-decoration:none;
                  "
                />
              </td>
            </tr>`
                : ""
            }

            <!-- BUTTON -->
            <tr>
              <td align="center" style="padding-bottom:10px;">
                <table cellpadding="0" cellspacing="0" role="presentation" width="100%">
                  <tr>
                    <td
                      style="
                        background:${f.styleButton?.color || "#2F80ED"};
                        border-radius:6px;
                        text-align:center;
                      "
                    >
                      <a
                        href="${MAIN_WEBSITE_URL}/preview/${paramsId}"
                        target="_blank"
                        style="
                          display:inline-block;
                          padding:10px 16px;
                          font-size:${f.styleButton?.fontSize || "14px"};
                          font-weight:600;
                          color:${f.styleButton?.textColor || "#ffffff"};
                          text-decoration:none;
                          border-radius:6px;
                          mso-padding-alt:0;
                        "
                      >
                        ${f.buttonText || "Submit"}
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <!-- TERMS -->
            <tr>
              <td
                style="
                  font-size:11px;
                  line-height:16px;
                  color:#7a7a7a;
                  text-align:center;
                "
              >
                By clicking "${f.buttonText || "Submit"}" you agree to Sided’s
                <a
                  href="https://sided.co/terms-of-service"
                  target="_blank"
                  style="color:#2F80ED;text-decoration:none;"
                >
                  Terms of Service
                </a>
                and
                <a
                  href="https://sided.co/privacy-policy"
                  target="_blank"
                  style="color:#2F80ED;text-decoration:none;"
                >
                  Privacy Policy
                </a>.
              </td>
            </tr>

          </table>
        </td>
      </tr>
    `;
  } else if (signup) {
    const s = signup;

    innerContent = `
      <!-- SIGNUP CONTENT -->
      <tr>
        <td colspan="2" style="padding:12px 20px;">
          <table width="100%" cellpadding="0" cellspacing="0" role="presentation">

            <!-- TITLE -->
            <tr>
              <td
                style="
                  color:${s.styleTitle?.color || "#333"};
                  font-family:open-sans, sans-serif;
                  font-size:${s.styleTitle?.fontSize || "13px"};
                  line-height:28px;
                  font-weight:700;
                  padding-bottom:4px;
                "
              >
                ${s.title || "Sign up"}
              </td>
            </tr>

            <!-- DESCRIPTION -->
            <tr>
              <td
                style="
                  color:${s.styleDescription?.color || "#4F4F4F"};
                  font-family:open-sans, sans-serif;
                  font-size:${s.styleDescription?.fontSize || "12px"};
                  font-weight:400;
                  padding-bottom:10px;
                "
              >
                ${s.description || "Polls, quizzes, and community"}
              </td>
            </tr>

            <!-- EMAIL INPUT (STATIC) -->
            <tr>
              <td style="padding-bottom:8px;">
                <div
                  style="
                    padding:10px;
                    border-radius:6px;
                    border:1px solid #E0E0E0;
                    font-size:13px;
                    font-family:open-sans, sans-serif;
                    color:#9B9B9B;
                  "
                >
                  Enter your email
                </div>
              </td>
            </tr>

            <!-- SIGNUP BUTTON -->
            <tr>
              <td align="center" style="padding-bottom:8px;  color:#27AE60;">
                <table cellpadding="0" cellspacing="0" role="presentation" width="100%">
                  <tr>
                    <td
                      style="
                        background:#27AE60;
                        border-radius:6px;
                        border:1px solid;
                        text-align:center;
                      "
                    >
                      <a
                        href="${MAIN_WEBSITE_URL}/preview/${paramsId}"
                        target="_blank"
                        style="
                          display:block;
                          padding:10px;
                          font-family:open-sans, sans-serif;
                          font-size:${s.styleButton?.fontSize || "14px"};
                          font-weight:600;
                          color:${s.styleButton?.textColor || "#ffffff"};
                          text-decoration:none;
                        "
                      >
                        ${s.buttonText || "Sign up"}
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <!-- GOOGLE SIGNUP (STATIC CTA) -->
            <tr>
              <td align="center" style="padding-bottom:10px;">
                <a
                  href="${MAIN_WEBSITE_URL}/preview/${paramsId}"
                  target="_blank"
                  style="
                    display:block;
                    padding:9px;
                    border:1px solid #E0E0E0;
                    border-radius:6px;
                    font-family:open-sans, sans-serif;
                    font-size:12px;
                    color:#333;
                    text-decoration:none;
                  "
                >
                  Sign in with Google
                </a>
              </td>
            </tr>

            <!-- TERMS -->
            <tr>
              <td
                style="
                  color:#9B9B9B;
                  font-family:open-sans, sans-serif;
                  font-size:10px;
                  line-height:14px;
                  text-align:left;
                  padding-bottom:10px;
                "
              >
                By signing up, you agree to receive voting-related emails from Sided, including poll results, community updates, and a secure login link.
                Read our
                <a href="https://sided.co/terms-of-service" target="_blank" style="color:#2F80ED;text-decoration:none;">
                  Terms of Service
                </a>
                and
                <a href="https://sided.co/privacy-policy" target="_blank" style="color:#2F80ED;text-decoration:none;">
                  Privacy Policy
                </a>.
              </td>
            </tr>

            <!-- LOGIN LINK -->
            <tr>
              <td
                style="
                  color:#9B9B9B;
                  font-family:open-sans, sans-serif;
                  font-size:10px;
                  text-align:center;
                "
              >
                Have an account?
                <a
                  href="${MAIN_WEBSITE_URL}/preview/${paramsId}"
                  target="_blank"
                  style="color:#2F80ED;text-decoration:none;"
                >
                  Login
                </a>
              </td>
            </tr>

          </table>
        </td>
      </tr>
    `;
  } else {
    innerContent = `
      
      <!-- TOP NAVIGATION -->
      ${topNavSteps}

      <!-- POLL THESIS -->
      <tr>
        <td colspan="2" style="padding:10px 20px 6px 20px"><div style="font-size:18px;line-height:15px;font-weight:700;color:#000;">${poll.thesis}</div></td>
      </tr>

      <!-- USER INFO -->
      <tr>
        <td colspan="2" style="padding:0 20px">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td style="padding-right:6px;vertical-align:middle">
                <img src="${userImage}" alt="${poll.user?.name}" width="15" height="15" style="display:block;width:15px;height:15px;border-radius:50%;border:1px solid #000;object-fit:cover;" />
              </td>
              <td style="vertical-align:middle">
                <span style="font-size:12px;color:#4F4F4F;font-weight:400">${poll.user?.name}${poll.isSponsored ? `<span style="color:#999"> • Sponsored</span>` : ""}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <!-- POLL META -->
      ${endedAtForMailEmbed ? `<tr><td colspan="2" style="padding:6px 20px 10px 20px"><span style="font-size:11px;color:#9b9b9b">${endedAtForMailEmbed}</span></td></tr>` : ""}

      <!-- SIDES -->
      <tr>
        <td colspan="2" style="padding:10px 20px"><table width="100%" cellpadding="0" cellspacing="0">${emailEmbedSides}</table></td>
      </tr>

      <!-- SIDED BOTTOM BAR -->
      <tr>
        <td colspan="2" style="border-top:1px solid #E9ECEF;padding:9px 0;text-align:center;">
          <table align="center" cellpadding="0" cellspacing="0">
            <tr>
              <td style="font-size:10px;line-height:10px;color:#4a4a4a;padding-right:5px;vertical-align:middle;">Powered by</td>
              <td style="vertical-align:middle">
                <a href="https://sided.com" target="_blank" rel="noreferrer" style="display:inline-block">
                  <img src="https://sided-stage-embed-v2.s3.us-east-2.amazonaws.com/logo.svg" alt="Sided logo" width="32" height="10" style="display:block;width:32px;height:10px;object-fit:fill;margin-bottom:0.4px;border:0;outline:none;" loading="lazy" />
                </a>
              </td>
            </tr>
          </table>
        </td>
      </tr>`;
  }

  const copyEmailEmbed = `
    <table style="max-width:300px;width:100%;margin:0 auto;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Helvetica Neue',sans-serif;color:#4a4a4a;font-size:12px;box-sizing:border-box;border:1px solid #E9ECEF;border-radius:3px;overflow:hidden;">
      ${innerContent}
    </table>`;

  try {
    if (navigator.clipboard && window.ClipboardItem) {
      const htmlBlob = new Blob([copyEmailEmbed], { type: "text/html" });
      const textPlain =
        new DOMParser().parseFromString(copyEmailEmbed, "text/html").body
          .textContent || copyEmailEmbed;
      const textBlob = new Blob([textPlain], { type: "text/plain" });
      await navigator.clipboard.write([
        new ClipboardItem({ "text/html": htmlBlob, "text/plain": textBlob }),
      ]);
      setAlertMessage("Email embed copied to clipboard!");
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = copyEmailEmbed;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setAlertMessage("Email embed copied to clipboard!");
    }
  } catch (err) {
    console.error(err);
    setAlertMessage("Failed to copy email embed.");
  }
}